import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import 'common/css/master.css';
import { getPatternSectionListSvc } from '../examPatternCreator/examPatternCreatorSvc';

function PatternSlider(props) {
    const { patternId, pattern: patternProp, patternDesc: patternDescProp, closeSlider, onSave } = props;

    const [loader, setLoader]                     = useState('none');
    const [pattern, setPattern]                   = useState('');
    const [patternDesc, setPatternDesc]           = useState('');
    const [lstSection, setLstSection]             = useState([]);
    const [currentPatternId, setCurrentPatternId] = useState(0);
    const [flgModal, setFlgModal] = useState(false);

    const [newSection, setNewSection] = useState({
    qusMm: '',
    noOfQus: '',
    qusToAttempt: '',
    qusTypeId: '',
    complexityLevel: '',
    sectionDesc: '',
});

    useEffect(() => {
        setPattern(patternProp || '');
        setPatternDesc(patternDescProp || '');
        setLstSection([]);
        setCurrentPatternId(patternId || 0);
        if (patternId) {
            getPatternSectionListSvc(patternId, (res) => {
                if (res.status === 'Success') {
                    setLstSection(res.lstPatternSection);
                } else {
                    toast.error(res.message);
                }
            });
        }
    }, [patternId]);

    const savePattern = () => {
        if (!pattern.trim()) {
            toast.warn('Pattern name is required');
            return;
        }
        if (onSave) {
            onSave(currentPatternId, pattern.trim(), patternDesc.trim(), (newPatternId) => {
                setCurrentPatternId(newPatternId);
            });
        }
    };

    

    return (
        <>
            <form
                className="form form-horizontal"
                style={{
                    pointerEvents: loader === 'none' ? 'auto' : 'none',
                    height: 'auto',
                    width: '90%',
                    margin: '10px auto',
                    background: '#fff',
                    border: '1px solid #ccc',
                    borderRadius: 10,
                }}
            >
                <button
                    type="button"
                    className="btn btn-info text-center btnCloseDiv"
                    onClick={closeSlider}
                >
                    <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
                </button>

                <div className="row" style={{ width: '100%' }}>
                    <div className="form-group col-md-6">
                        <label className="control-label col-sm-5">Pattern<span className="red-color">*</span></label>
                        <div className="col-sm-6 padding-remove">
                            <input
                                type="text"
                                className="form-control" 
                                value={pattern}
                                onChange={(e) => setPattern(e.target.value)}
                                placeholder="Enter pattern name"
                            />
                        </div>
                    </div>
                </div>

                <div className="row" style={{ width: '100%' }}>
                    <div className="form-group col-md-6">
                        <label className="control-label col-sm-5">Description</label>
                        <div className="col-sm-6 padding-remove">
                            <input
                                type="text"
                                className="form-control"
                                value={patternDesc}
                                onChange={(e) => setPatternDesc(e.target.value)}
                                placeholder="Enter description"
                            />
                        </div>
                    </div>
                </div>

                <div className="row" style={{ width: '100%', paddingBottom: '1px' }}>
                    <div className="col-md-offset-10 col-md-1 padding-remove">
                        <button
                            type="button"
                            className="btn btn-info pull-right"
                            onClick={savePattern}
                        >
                            Save
                        </button>
                    </div>
                </div>
            </form>

            {currentPatternId > 0 && (
                <form
                    className="form form-horizontal"
                    style={{
                        height: 'auto',
                        width: '90%',
                        margin: '10px auto',
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: 10,
                    }}
                >
                    <div className="row" style={{ width: '100%', padding: '10px 0' }}>
                     <div className="col-md-12 text-right">
                       <button
                         type="button"
                         className="btn btn-info"
                        onClick={() => setFlgModal(true)}
                       >
                     Add Section
                    </button>
                  </div>
              </div>
                    <div className="row" style={{ width: '100%' }}>
                        <div className="col-md-12" style={{ padding: '10px 20px' }}>
                            <table className="tableLayout1">
                                <colgroup>
                                    <col width="8%" />
                                    <col width="18%" />
                                    <col width="18%" />
                                    <col width="18%" />
                                    <col width="18%" />
                                    <col width="20%" />
                                </colgroup>
                                <thead>
                                    <tr>
                                        <th>Section</th>
                                        <th>Marks/Q</th>
                                         <th>Question Type</th>
                                        <th>Total Questions</th>
                                        <th>To Attempt</th>
                                        <th>Difficulty</th>
                                    </tr>
                                </thead>
                            </table>
                            <div className="tablebodyWrapper">
                                <table className="tableLayout">
                                    <colgroup>
                                        <col width="8%" />
                                        <col width="18%" />
                                        <col width="18%" />
                                        <col width="18%" />
                                        <col width="18%" />
                                        <col width="20%" />
                                    </colgroup>
                                    <tbody>
                                        {lstSection.length === 0 ? (
                                            <tr>
                                                <td colSpan={6} className="text-center">No sections found</td>
                                            </tr>
                                        ) : (
                                            lstSection.map((sec, idx) => (
                                                <tr key={idx}>
                                                    <td className="text-center">{String.fromCharCode(65 + idx)}</td>
                                                    <td className="text-center">{sec.qusMm}</td>
                                                    <td className="text-center">{sec.noOfQus}</td>
                                                    <td className="text-center">{sec.qusToAttempt}</td>
                                                    <td className="text-center">{sec.complexityLevel}</td>
                                                    <td className="text-center">{sec.qusType}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </form>
            )}
            {flgModal && (
    <div className="modal-overlay" onClick={() => setFlgModal(false)}>
        <div className="modal-content" style={{ padding: 40 }} onClick={(e) => e.stopPropagation()}>
            <button type="button" className="btn btn-info text-center" id="closeSlider"
                onClick={() => setFlgModal(false)}
                style={{ right: '-25px', top: '-25px', position: 'absolute', opacity: 1 }}>
                <span className="glyphicon glyphicon-remove"></span>
            </button>

            <h4>Add Section</h4>

            <div className="form-group">
                <label className="control-label col-sm-5">Marks/Question</label>
                <div className="col-sm-6 padding-remove">
                    <input type="number" className="form-control"
                        value={newSection.qusMm}
                        onChange={(e) => setNewSection({ ...newSection, qusMm: e.target.value })} />
                </div>
            </div>
            <div className="form-group">
                <label className="control-label col-sm-5">Total Questions</label>
                <div className="col-sm-6 padding-remove">
                    <input type="number" className="form-control"
                        value={newSection.noOfQus}
                        onChange={(e) => setNewSection({ ...newSection, noOfQus: e.target.value })} />
                </div>
            </div>
            <div className="form-group">
                <label className="control-label col-sm-5">To Attempt</label>
                <div className="col-sm-6 padding-remove">
                    <input type="number" className="form-control"
                        value={newSection.qusToAttempt}
                        onChange={(e) => setNewSection({ ...newSection, qusToAttempt: e.target.value })} />
                </div>
            </div>
            <div className="form-group">
                <label className="control-label col-sm-5">Difficulty</label>
                <div className="col-sm-6 padding-remove">
                    <select className="form-control"
                        value={newSection.complexityLevel}
                        onChange={(e) => setNewSection({ ...newSection, complexityLevel: e.target.value })}>
                        <option value="">Select</option>
                        <option value="Easy">Easy</option>
                        <option value="Medium">Medium</option>
                        <option value="Difficult">Difficult</option>
                    </select>
                </div>
            </div>
            <div className="form-group">
                <label className="control-label col-sm-5">Description</label>
                <div className="col-sm-6 padding-remove">
                    <input type="text" className="form-control"
                        value={newSection.sectionDesc}
                        onChange={(e) => setNewSection({ ...newSection, sectionDesc: e.target.value })} />
                </div>
            </div>

            <div className="text-right" style={{ marginTop: 20 }}>
                <button type="button" className="btn btn-info">Save</button>
            </div>
        </div>
    </div>
)}


        </>
    );
}

export default PatternSlider;
